import React from 'react';
import InactiveRepsList from 'components/coaching/landing-pages/InactiveRepsList';

export default class InactiveRepsTabPanel extends React.Component {
  /**
   * The Rep list and Inactive Rep List components both will not render if they're
   * empty. And if only one renders that means that it holds the entirety of
   * the manager's team.
   *
   * This method captures different headers for the different possible states of the table.
   *
   * If you make changes to this method please also check the logic for computing ActiveRepsList headers in RepLists.js
   *
   */
  tableHeader() {
    const {authUser, manager, haveActiveReps, areCoachingPlansLoading} = this.props;

    if (areCoachingPlansLoading) return '';

    if (haveActiveReps) {
      return 'REPS WITHOUT ACTIVE COACHING PLAN';
    }

    if (authUser && authUser.isAdmin()) {
      return `${manager.getFullName()}'s TEAM`;
    } else {
      return 'YOUR TEAM';
    }
  }

  render() {
    const {coachingPlans, directReports, managerId} = this.props;

    if (!coachingPlans) {
      return null;
    }

    const minusManager = directReports.filter(rep => rep.userId !== managerId);

    // gather reps and whether they have plans
    const repsWithPlans = directReports.filter(rep =>
      coachingPlans.find(plan => plan.recipient.id === rep.userId)
    );

    const repsWithoutPlans = minusManager.filter(rep => !repsWithPlans.includes(rep));

    return <InactiveRepsList {...this.props} inactiveReps={repsWithoutPlans} />;
  }
}
